import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { AppFilter, User } from 'src/modules/shared/';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';
import { WorkFlowService } from '../../services/workflow.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ChatService } from 'src/modules/features/admin/services';

interface IAssignSubtopicModalContext {
  title: string;
  data: any;
  appUserIds: any;
}

@Component({
  selector: 'app-assign-subtopic-modal',
  templateUrl: './assign-subtopic-modal.component.html',
  styleUrls: ['./assign-subtopic-modal.component.scss'],
})
export class AssignSubtopicModalComponent implements OnInit {
  baseUrl = environment.API_SERVER;

  pending: boolean;
  success: any;
  error: any;
  filter: AppFilter = new AppFilter();

  data;
  allUsers: any;
  assignForm: FormGroup;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  selectedUsers = [];
  unselectedUsers = [];
  search = new FormControl('');
  constructor(
    public modal: SuiModal<IAssignSubtopicModalContext, void, void>,
    private fb: FormBuilder,
    private workflowService: WorkFlowService,
    private chatService: ChatService
  ) {
    this.selectedUsers = this.modal.context.appUserIds;
    this.data = modal.context.data;
    console.log(this.data, 'data');
    this.getUsers('');
    this.assignForm = fb.group({
      // topic: ['', Validators.required]
    });
    this.search.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchText) => {
        this.searchUser(searchText);
      });
  }

  ngOnInit() {}

  submit() {
    if (!this.isButtonDisabled()) {
      this.save();
    }
  }
  allUsersSelected = false;
  // checkChange(id, event) {
  //   if (event) {
  //     this.selectedUsers.push(id);
  //   } else {
  //     this.selectedUsers.forEach((u) => {
  //       if (u == id) {
  //         this.selectedUsers.splice(this.selectedUsers.indexOf(id), 1);
  //       }
  //     });
  //   }
  // }
  toggleAllUsers(event) {
    this.allUsersSelected = event;

    this.unselectedUsers.forEach((user) => (user.checked = event));
  }
  trackByUserId(index: number, user: any): number {
    return user.appUserId;
  }
  checkChange(user, event) {
    user.checked = event;
    this.allUsersSelected = this.areAllUsersSelected();
  }

  areAllUsersSelected(): boolean {
    return (
      this.unselectedUsers.length > 0 &&
      this.unselectedUsers.every((user) => user.checked)
    );
  }
  getCheckedUsers() {
    return this.unselectedUsers.filter((user) => user.checked);
  }

  isButtonDisabled(): boolean {
    return this.getCheckedUsers().length === 0;
  }
  // isChecked(id) {
  //   if (this.selectedUsers.filter((i) => i == id).length > 0) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // toggleAllUsers(event) {
  //   if (event) {
  //     // Deselect all users
  //     this.selectedUsers = this.unselectedUsers.map((user) => user.appUserId);
  //   } else {
  //     // Select all users
  //     this.selectedUsers = [];
  //   }
  // }

  // areAllUsersSelected(): boolean {
  //   return (
  //     this.unselectedUsers.length > 0 &&
  //     this.selectedUsers.length === this.unselectedUsers.length
  //   );
  // }
  // checkChange(id, event) {
  //   if (event) {
  //     if (!this.selectedUsers.includes(id)) {
  //       this.selectedUsers.push(id);
  //     }
  //   } else {
  //     const index = this.selectedUsers.indexOf(id);
  //     if (index > -1) {
  //       this.selectedUsers.splice(index, 1);
  //     }
  //   }
  // }

  // isChecked(id): boolean {
  //   return this.selectedUsers.includes(id);
  // }
  getUsers(search) {
    this.pending = true;
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 1000000,
      sord: 'desc',
    });
    if (search !== '') {
      this.filter.filters = JSON.stringify(search);
    }
    this.workflowService
      .getNewEndpointAppUsers({
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.totalItems = +res.records - this.selectedUsers.length;
          this.rows = this.filter.rows;
          this.allUsers = res['rows'] as Array<User>;
          this.allUsers = this.allUsers.map((obj) => {
            if (obj.image) {
              return {
                ...obj,
                image: `${this.baseUrl}/public/image/?media=${obj.image.replace(
                  /\\/g,
                  '/'
                )}`,
              };
            } else {
              return obj;
            }
          });
          console.log(this.allUsers);
          this.unselectedUsers = this.allUsers.filter(
            (elem) =>
              !this.selectedUsers.find(
                (appUserId) => elem.appUserId === appUserId
              )
          );
          this.selectedUsers = this.allUsers.filter((elem) =>
            this.selectedUsers.find((appUserId) => elem.appUserId === appUserId)
          );
          console.log('selectedUsers ', this.selectedUsers);
          this.selectedUsers.forEach((u) => {
            if (u['firstName'] === null) {
              u['firstName'] = u['appUserEmail'];
            }
            if (u['lastName'] === null) {
              u['lastName'] = '';
            }
            u.name = `${u['firstName']} ${u['lastName']}`;
          });
          this.unselectedUsers.forEach((u) => {
            if (u['firstName'] === null) {
              u['firstName'] = u['appUserEmail'];
            }
            if (u['lastName'] === null) {
              u['lastName'] = '';
            }
            u.name = `${u['firstName']} ${u['lastName']}`;
          });
          console.log(this.selectedUsers, 'users');
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  save() {
    this.pending = true;
    let data = [];

    this.getCheckedUsers().map((item) => {
      if (item.appUserId) {
        data.push(item.appUserId);
      } else {
        data.push(item);
      }
    });
    let body = data.map((user) => {
      return {
        appUserId: user,
        subtopicId: this.modal.context.data.subtopicId,
        read: true,
        write: true,
        watch: true,
        delete: true,
      };
    });
    this.chatService
      .assignUserSubTopic({
        body: { permissions: body },
      })
      .subscribe(
        (e) => {
          this.success = 'User Assigned to SubTopic successfully';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.message
            ? error.error.message
            : error
            ? error.error
            : error;
        }
      );
  }
  searchUser(search) {
    if (search === '') {
      this.filter = new AppFilter({ sidx: 'dateCreated' });
      this.getUsers('');
    } else {
      let searchFilter = {
        groupOp: 'OR',
        rules: [
          {
            field: 'appUserEmail',
            op: 'cn',
            data: '',
          },
          {
            field: 'lastName',
            op: 'cn',
            data: '',
          },
          {
            field: 'firstName',
            op: 'cn',
            data: '',
          },
        ],
      };
      searchFilter.rules[0].data = search;
      searchFilter.rules[1].data = search;
      searchFilter.rules[2].data = search;
      this.filter.filters = JSON.stringify(searchFilter);
      this.getUsers(searchFilter);
    }
  }
  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getUsers('');
  }
}

export class AssignSubtopicModal extends ComponentModalConfig<
  IAssignSubtopicModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    appUserIds: any,
    size: ModalSize = ModalSize.Mini
  ) {
    super(AssignSubtopicModalComponent, {
      title: title,
      data: data,
      appUserIds: appUserIds,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
